import { render, staticRenderFns } from "./NicheNewList.vue?vue&type=template&id=c3c4053a&scoped=true"
import script from "./NicheNewList.vue?vue&type=script&lang=js"
export * from "./NicheNewList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3c4053a",
  null
  
)

export default component.exports